import { Box, Button } from '@mui/material';
import { AccessDenied, useLogout, useTranslate } from 'react-admin';

export const AccessDeniedPage = () => {
    const logout = useLogout();
    const translate = useTranslate();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                gap: 2,
            }}
        >
            <AccessDenied sx={{ height: 'auto' }} />
            <Button variant="contained" onClick={() => logout()}>
                {translate('ra.auth.logout', { _: 'Logout' })}
            </Button>
        </Box>
    );
};
